import { render, staticRenderFns } from "./PromotionRecord.vue?vue&type=template&id=75f1920c&scoped=true&"
import script from "./PromotionRecord.vue?vue&type=script&lang=js&"
export * from "./PromotionRecord.vue?vue&type=script&lang=js&"
import style0 from "./PromotionRecord.vue?vue&type=style&index=0&id=75f1920c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f1920c",
  null
  
)

export default component.exports